import { AccordionSection } from '@medifind/containers';
import { Skeleton } from '@medifind/shared-basic-components';
import classNames from 'classnames';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialContacts = ({ contacts, isLoading }) => {
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Contact Information"
      isLoading={isLoading}
    >
      {contacts ? (
        contacts.map(({ contactType, name, email, phone }, i) => {
          return (
            <div key={i} style={{ marginBottom: 16 }}>
              {contactType && (
                <div className={styles['section-border']}>
                  <span className={classNames(styles['section-body-text'], styles['bold'])}>{contactType}</span>
                </div>
              )}
              {name && <div>{name}</div>}
              {email && <div>{email}</div>}
              {phone && <div>{phone}</div>}
            </div>
          );
        })
      ) : (
        <Skeleton count={6} />
      )}
    </AccordionSection>
  );
};

export { ClinicalTrialContacts as default, ClinicalTrialContacts };
